import { render, staticRenderFns } from "./NJ-PH-Notice.vue?vue&type=template&id=5fe19b46&scoped=true&"
import script from "./NJ-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./NJ-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./NJ-PH-Notice.vue?vue&type=style&index=0&id=5fe19b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe19b46",
  null
  
)

export default component.exports